import React from 'react';
import style from './Certificate.module.scss';
import { useAuth } from '../../../contexts/auth';
import { getProjectId, getSourceValue, handleRedirection } from '../../../lib/common';
import { handleImpressionsTrack } from '../../../api';

const Certificate = () => {
  const [authState] = useAuth();
  const { selectedBusiness } = authState;
  const source = getSourceValue();
  const projectId = getProjectId();

  const handleBannerRedirection = async () => {
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `cta_buynow`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `issue_jdrrCertificate`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
      const url = `https://www.justdial.com/JDRR-${
        selectedBusiness?.shorturl || ''
      }?hide_header=1&support=1&source=${source}`;
      // Opening the url in new tab.
      // if (andriodSource.includes(source) || iosSource.includes(source)) {
      //   window.open(url);
      // } else {
      //   window.location = url;
      // }

      handleRedirection(source, url);
    }
  };

  return (
    <div className={`${style.Box}`}>
      <div className={`${style.BoxInner}`}>
        <div className={`${style.ImageBox}`}>
          <img
            alt="certificate"
            className={`${style.Image}`}
            src="https://akam.cdn.jdmagicbox.com/images/icons/genio/JDRR_image_withoutname1_2025.png"
          />
          <div className={`${style.ImageBoxInner}`}>
            <div className={`${style.star_outer}`}>
              <span className={`${style.star} ${style.bigstar10}`} />
              <span className={`${style.star} ${style.bigstar10}`} />
              <span className={`${style.star} ${style.bigstar10}`} />
              <span className={`${style.star} ${style.bigstar10}`} />
              <span className={`${style.star} ${style.bigstar6}`} />
            </div>
            <div className={`${style.Name}  fw700 color111`}>Your Business Name</div>
          </div>
        </div>
        <div className={`${style.Content}`}>
          <div className="font18 fw600 color111 pt-15 pl-15 pr-15">Elevate Your Business with JDRR Certificate! </div>
          <ul className={`${style.List} mt-12`}>
            <li className={`${style.Item}`}>
              <div className="font14 fw600 color111">Boost Credibility</div>
              <div className="font13 fw400 color111">
                Showcase your framed reviews to walk-in customers and establish trust in your brand.
              </div>
            </li>
            <li className={`${style.Item}`}>
              <div className="font14 fw600 color111">Stand Out from the Crowd </div>
              <div className="font13 fw400 color111">
                Boost your brand and get noticed with the help of the JDRR certificate.
              </div>
            </li>
          </ul>
          <div className={`${style.ButtonBox}`}>
            <div className="font13 fw600 color111">Get your JDRR Certificate now</div>
            <button
              onClick={() => handleBannerRedirection()}
              type="button"
              className={`${style.Button} bluefill_animate font13 fw600 colorFFF`}
            >
              Buy Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Certificate;
